import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { useI18n } from "../../lib/i18n";
import type { Club } from "../../lib/api/lidoo.functions";
import { ClubCard, priceLine } from "./club-card";
import { ClubsMap } from "./club-map";

export function ClubsView({
  clubs,
}: {
  clubs: (Club & { distanceKm?: number })[];
}) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [mode, setMode] = useState<"list" | "map">("list");

  return (
    <div>
      <div className="mb-5 flex justify-end">
        <button
          type="button"
          onClick={() => setMode(mode === "list" ? "map" : "list")}
          className="li-mono flex items-center gap-1.5 rounded-md border border-[#1C2430]/20 px-3 py-1.5 text-[11px] text-[#1C2430] transition-colors hover:border-[#2C4FD6]"
        >
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#2C4FD6]" />
          {mode === "list" ? t("show_map") : t("show_list")}
        </button>
      </div>

      {mode === "map" ? (
        <ClubsMap
          clubs={clubs.map((c) => ({
            slug: c.slug,
            name: c.name,
            lat: c.lat ?? NaN,
            lng: c.lng ?? NaN,
            priceLine: priceLine(c, t),
          }))}
          onSelect={(slug) => void navigate({ to: "/club/$slug", params: { slug } })}
        />
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {clubs.map((club) => (
            <ClubCard key={club.slug} club={club} distanceKm={club.distanceKm ?? null} />
          ))}
        </div>
      )}
    </div>
  );
}
